import { createSlice } from '@reduxjs/toolkit'
import reducers from 'store/features/tts/reducers'
import { getInitialState } from 'store/features/tts/initialState'

const ttsSlice = createSlice({
  name: 'tts',
  initialState: getInitialState(),
  reducers
})

export default ttsSlice
